import $ from 'jquery';
import 'jquery.cookie';

export { $ };
window.$ = $;
window.jQuery = $;

import * as bannersInner from '@banners';
import * as topCommentsInner from '@top-comments';

// leaf module, not utils/fn: fn.js has top-level side effects and would be
// duplicated into this bundle alongside the main js build
import { exportGetScript, getScript } from '../../../src/js/common/utils/get-script';

window.fn = window.fn ?? {};
window.fn.banners = bannersInner;
window.fn.topComments = topCommentsInner;
window.getScript = exportGetScript;

Object.assign(window.fn, {
  getScript,
});

import '../consent/msnt-consent';

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

window.fn.banners.banners();

// msntConsent.initShareBlock($('.postBody'));
